import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import VerbText from './VerbText';

class VerbDropdownMenu extends Component {
    static propTypes = {
        children: PropTypes.object,
        className: PropTypes.string,
        dropdownHeader: PropTypes.string,
        dropdownData: PropTypes.arrayOf(
            PropTypes.shape({
                textId: PropTypes.string,
                text: PropTypes.string,
                icon: PropTypes.string,
                onClick: PropTypes.func,
                linkProps: PropTypes.object
            })
        ),
        popoverPlacement: PropTypes.string
    };

    _makeDropdown = () => {
        const { dropdownData, dropdownHeader, className } = this.props;
        return (
            <Popover id={'verb-dropdown'} className={cns('verb-dropdown-menu', className)}>
                {dropdownHeader && <p className={'verb-dropdown-menu-header'}>{dropdownHeader}</p>}
                {dropdownData.map((item, i) => {
                    let displayText = item.text;
                    if (item.textId) {
                        displayText = <VerbText messageId={item.textId} defaultMessage={item.text} />;
                    }
                    if (item.linkProps) {
                        return (
                            <Link key={item.text} {...item.linkProps}>
                                <div className={'verb-dropdown-menu-options row'}>
                                    {item.fontAwesomeIcon && (
                                        <i
                                            className={cns(
                                                'icon fa-fw',
                                                item.fontAwesomeIconWeight,
                                                item.fontAwesomeIcon
                                            )}
                                        />
                                    )}
                                    <span>{displayText}</span>
                                </div>
                            </Link>
                        );
                    }

                    if (item.anchorTag && item.anchorTag.href) {
                        return (
                            <a href={item.anchorTag.href} target={item.anchorTag.newTab ? '_blank' : undefined}>
                                <div className={'verb-dropdown-menu-options row'}>
                                    {item.fontAwesomeIcon && (
                                        <i
                                            className={cns(
                                                'icon fa-fw',
                                                item.fontAwesomeIconWeight,
                                                item.fontAwesomeIcon
                                            )}
                                        />
                                    )}
                                    <span>{displayText}</span>
                                </div>
                            </a>
                        );
                    }

                    if (item.onClick) {
                        return (
                            <div
                                key={item.text}
                                onClick={() => {
                                    item.onClick();
                                    document.body.click();
                                }}
                                className={'verb-dropdown-menu-options row'}
                            >
                                {item.fontAwesomeIcon && (
                                    <i
                                        className={cns('icon fa-fw', item.fontAwesomeIconWeight, item.fontAwesomeIcon)}
                                    />
                                )}
                                <span>{displayText}</span>
                            </div>
                        );
                    }
                    return (
                        <div key={item.text} className={'row'}>
                            {item.fontAwesomeIcon && (
                                <i className={cns('icon fa-fw', item.fontAwesomeIconWeight, item.fontAwesomeIcon)} />
                            )}
                            <span>{displayText}</span>
                        </div>
                    );
                })}
            </Popover>
        );
    };

    render() {
        const { popoverPlacement = 'bottom' } = this.props;
        return (
            <OverlayTrigger
                trigger={'click'}
                rootClose
                placement={popoverPlacement}
                transition={false}
                overlay={this._makeDropdown()}
            >
                {this.props.children}
            </OverlayTrigger>
        );
    }
}

export default VerbDropdownMenu;
